export const DRY_BAR_SERIES_UUID = 'e0fdd87d-843c-4f0d-9659-fde19216eb4e'
